<template>
  <div id="wechatSetting">
    <h1>账号绑定</h1>
    <el-row :gutter="20" class="title">
      <el-col :span="6">功能</el-col>
      <el-col :span="6">说明</el-col>
      <el-col :span="6">状态</el-col>
      <el-col :span="6">操作</el-col>
    </el-row>
    <!-- <el-row :gutter="20" class="content">
      <el-col :span="6">微信授权</el-col>
      <el-col :span="6" style="color: #999">绑定后可微信授权</el-col>
      <el-col :span="6">{{wechatStatus == 1 ? "已绑定" : "未绑定"}}</el-col>
      <el-col :span="6">
        <el-button size="mini" round @click="authorizationBind">{{wechatStatus == 1 ? "重新绑定" : "绑定"}}</el-button>
        <el-button v-if="wechatStatus == 1" size="mini" round @click="deleteBind">清除</el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="content">
      <el-col :span="6">支付设置</el-col>
      <el-col :span="6" style="color: #999">设置后可使用微信支付；开通微信支付后，您将收到财付通的邮件通知，请将邮件中的参数填写到这里</el-col>
      <el-col :span="6">{{wechatPayStatus == 1 ? "已绑定" : "未绑定"}}</el-col>
      <el-col :span="6">
        <el-button size="mini" round @click="bindWechatPay" v-if="wechatPayStatus == 0">绑定</el-button>
        <el-button size="mini" round @click="deleteWechatPay" v-if="wechatPayStatus == 1">清除</el-button>
      </el-col>
    </el-row>-->
    <el-row :gutter="20" class="content">
      <el-col :span="6">微信客服二维码</el-col>
      <el-col :span="6" style="color: #999">绑定后用户可以在我的频道查看客服微信</el-col>
      <el-col :span="6">{{wechatqrcode == 1 ? "已绑定" : "未绑定"}}</el-col>
      <el-col :span="6">
        <el-button size="mini" round @click="bindWechatQrcode">{{wechatqrcode == 1 ? "重新绑定" : "绑定"}}</el-button>
      </el-col>
    </el-row>
    <h1>微信白名单设置</h1>
    <p>服务器IP：47.110.124.227</p>
    <p>请复制至微信公众平台：开发-》基本配置-》白名单</p>
    <el-dialog title="支付设置" :visible.sync="dialogVisible" width="40%" :before-close="handleClose">
      <el-form
        :model="wechatPay"
        :rules="rules"
        ref="wechatPay"
        label-width="200px"
        class="demo-ruleForm"
      >
        <el-form-item label="微信支付商户号MCHID" prop="mchid">
          <el-input v-model="wechatPay.mchid"></el-input>
        </el-form-item>
        <el-form-item label="KEY" prop="secretKey">
          <el-input v-model="wechatPay.secretKey"></el-input>
        </el-form-item>
        <el-form-item label="Cret证书" required>
          <el-upload
            class="upload-demo"
            action
            :on-change="handleFileSuccess"
            :auto-upload="false"
            :file-list="fileList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传一个证书文件</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="bindWechatPaySure">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="客服微信绑定"
      :visible.sync="wechatQrcodeVisible"
      width="40%"
      :before-close="beforeWechatQrcodeClose"
    >
      <el-upload
        ref="upload"
        action="/upload/sysConfig/upload"
        list-type="picture-card"
        :limit="1"
        :on-success="uploadQrcodeSuccess"
        :on-remove="removeQrcode"
        :file-list="qrcodeFileList"
      >
        <i class="el-icon-plus icon-uploader-icon"></i>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="wechatQrcodeVisible = false">取 消</el-button>
        <el-button type="primary" @click="bindWechatQrcodeSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import utils from "../utils/utils";
export default {
  name: "wechat-setting",
  data() {
    return {
      sysConfig: {
        appid: "",
        preAuthCode: ""
      },
      wechatStatus: "",
      dialogVisible: false,
      wechatPay: {
        mchid: "",
        secretKey: ""
      },
      rules: {
        mchid: [
          {
            required: true,
            message: "请填写微信支付商户号MCHID",
            trigger: "blur"
          }
        ],
        secretKey: [{ required: true, message: "请填写key", trigger: "blur" }]
      },
      fileList: [],
      wechatPayStatus: "",
      cretFile: null,
      wechatqrcode: "",
      wechatQrcodeVisible: false,
      qrcodeFileList: [],
      qrcodeImageUrl: ""
    };
  },
  created() {
    this.getWechatSetting();
  },
  methods: {
    getWechatSetting() {
      utils.axiosMethods({
        method: "GET",
        url: "/api/wechat/getWechatSetting",
        callback: res => {
          if (res.data.code == 0) {
            this.wechatStatus = 1;
            if (res.data.obj.mchid) {
              this.wechatPayStatus = 1;
            } else {
              this.wechatPayStatus = 0;
            }
            if (res.data.obj.sysManageQrcode) {
              this.wechatqrcode = 1;
              this.qrcodeFileList = [{ url: res.data.obj.sysManageQrcode }];
            } else {
              this.wechatqrcode = 0;
            }
          } else {
            this.wechatStatus = 0;
            this.wechatPayStatus = 0;
            this.wechatqrcode = 0;
          }
        }
      });
    },
    getPreAuthCode() {
      utils.axiosMethods({
        method: "GET",
        url: "/api/wechat/getPreAuthCode",
        callback: res => {
          if (res.data.code == 0) {
            this.sysConfig.appid = res.data.obj.appid;
            this.sysConfig.preAuthCode = res.data.obj.preAuthCode;
            utils.axiosMethods({
              method: "GET",
              url: "/api/sysConfig/getSysConfigByType?type=0",
              callback: r => {
                console.log(r);
              //   window.open(
              //     "http://www.mumetech.com/api/authorizationBind?appid=" +
              //       this.sysConfig.appid +
              //       "&preAuthCode=" +
              //       this.sysConfig.preAuthCode +
              //       "&companyId=" +
              //       this.getCookie("companyId") +
              //       "&domain=" +
              //       location.origin,
              //     "newwindow",
              //     "height=800,width=800,top=50,left=100,toolbar=no,menubar=no,scollbar=no,resiable=no,location=no,status=no"
              //   );
              }
            });
          }
        }
      });
    },
    authorizationBind() {
      this.getPreAuthCode();
    },
    deleteBind() {
      utils.axiosMethods({
        method: "GET",
        url: "/api/wechat/deleteWechatSetting",
        callback: res => {
          if (res.data.code == 0) {
            this.$alert(
              "系统绑定数据已删除成功，如要彻底清除授权信息，请管理员登录公众号管理-》公众号设置-》授权管理进行授权删除",
              "提示"
            );
            this.getWechatSetting();
          }
        }
      });
    },
    bindWechatPay() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    beforeWechatQrcodeClose() {
      this.wechatQrcodeVisible = false;
    },
    handleFileSuccess(file, files) {
      this.cretFile = file.raw;
      this.fileList = [{ name: file.name, url: URL.createObjectURL(file.raw) }];
    },
    bindWechatPaySure() {
      this.$refs.wechatPay.validate(valid => {
        if (valid) {
          if (this.fileList.length > 0) {
            let formData = new FormData();
            formData.append("file", this.cretFile);
            formData.append("mchid", this.wechatPay.mchid);
            formData.append("secretKey", this.wechatPay.secretKey);
            utils.axiosMethods({
              method: "POST",
              url: "/api/wechat/bindWechatPay",
              data: formData,
              callback: res => {
                if (res.data.code == 0) {
                  this.$message.success("绑定成功");
                  this.getWechatSetting();
                  this.dialogVisible = false;
                } else {
                  this.$message.error(res.data.msg);
                }
              }
            });
          } else {
            this.$message.error("请上传证书");
          }
        }
      });
    },
    bindWechatQrcode() {
      this.wechatQrcodeVisible = true;
    },
    bindWechatQrcodeSure() {
      let formData = new FormData();
      formData.append("sysManageQrcode", this.qrcodeImageUrl);
      utils.axiosMethods({
        method: "POST",
        url: "/api/wechat/bindWechatQrcode",
        data: formData,
        callback: res => {
          if (res.data.code == 0) {
            this.$message.success("绑定成功");
            this.getWechatSetting();
            this.wechatQrcodeVisible = false;
          } else {
            this.$message.error(res.data.msg);
          }
        }
      });
    },
    deleteWechatPay() {
      utils.axiosMethods({
        method: "GET",
        url: "/api/wechat/deleteWechatPay",
        callback: res => {
          if (res.data.code == 0) {
            this.$alert("支付信息删除成功", "提示");
            this.getWechatSetting();
          }
        }
      });
    },
    uploadQrcodeSuccess(response, file, fileList) {
      let qrcodeImageUrl = [];
      fileList.forEach(item => {
        qrcodeImageUrl.push(item.response);
      });
      this.qrcodeImageUrl = qrcodeImageUrl.join(";");
    },
    removeQrcode(file, fileList) {
      let qrcodeImageUrl = [];
      fileList.forEach(item => {
        qrcodeImageUrl.push(item.response);
      });
      this.qrcodeImageUrl = qrcodeImageUrl.join(";");
      // 删除原有图片
      utils.axiosMethods({
        method: "POST",
        url: "/upload/sysConfig/deletefile",
        params: {
          url: file.response ? file.response : file.url
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
#wechatSetting {
  .title {
    text-align: center;
    font-weight: bold;
  }
  .content {
    text-align: center;
    font-size: 14px;
    margin: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/wechatSetting.vue